import React from 'react';
import { Button, Modal } from 'react-bootstrap';

//Thank you model content
export const ThankyouModal = (props) => {
	return (
		<Modal {...props} aria-labelledby='contained-modal-title-vcenter' dialogClassName='modal-md modal-box' className="thankyou-modal" backdrop="static" keyboard={false}>
			<Modal.Header
				closeButton
				className='modal-header border-0'>
					<h4> {props.stolemeta &&  props.stolemeta.savedDesignAlert && props.stolemeta.savedDesignAlert.title}</h4>
				</Modal.Header>
			<Modal.Body>
				<p>{props.stolemeta &&  props.stolemeta.savedDesignAlert && props.stolemeta.savedDesignAlert.info}</p>
			</Modal.Body>
			<Modal.Footer>
			  <Button variant='white' className='modal-btn' onClick={props.onHide} style={{ margin: '0 auto'}}>
			  {props.stolemeta &&  props.stolemeta.savedDesignAlert && props.stolemeta.savedDesignAlert.okBtn}
			</Button>
			</Modal.Footer>
		</Modal>
	);
};
